module.exports = __webpack_public_path__ + "static/media/landmannalaugar.3a5efb04.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Header/images/backgrounds/landmannalaugar.png
 ** module id = 187
 ** module chunks = 0
 **/